import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitCtisid = async (ctisid = null, apiToken = null) => {
    if (!ctisid) {
        console.log("no ctisid");
        return null;
    }
    console.log("CALLING SERVER with submitctisid")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitctisid',
            'apiToken': apiToken,
            'tool': "ctistofhirconverter",
            'ctisid': ctisid || "",
            'addtodatabase': true,
            'status': "active",
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitctisid call");
    }).catch((error) => { console.log(error); });
};

export default submitCtisid;